import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  clearFormQuote,
  setFormQuote,
  setQuoteFlow,
  setOriginChannel,
  getBiddingGuaranteeData,
} from 'store/modules/conlicitaseg_store/actions';
import { GuaranteeType } from 'store/modules/conlicitaseg_store/types';
import { useQuery } from 'services/query_services';
import { getQuoteStepPath } from 'services/conlicitaseg_flow';
import Loader from 'components/atoms/loader';

const BiddingQuoteStart: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();

  const biddingId = Number(query.get('bidding_id'));
  const rawType = query.get('tipo');
  const type: GuaranteeType = rawType === 'participacao' || rawType === 'execucao' ? rawType : null;

  useEffect(() => {
    if (!type || !Number.isInteger(biddingId) || biddingId <= 0) {
      history.replace('/conlicitaseg');
      return;
    }

    const isParticipacao = type === 'participacao';

    dispatch(clearFormQuote());
    dispatch(
      setFormQuote({
        bidding_id: biddingId,
        ...(isParticipacao ? { type_warranty_id: 'Licitante' } : {}),
      }),
    );
    dispatch(setQuoteFlow('bidding', type));
    dispatch(setOriginChannel('ia'));
    dispatch(getBiddingGuaranteeData(biddingId, type));

    history.replace(getQuoteStepPath(isParticipacao ? 'tomador' : 'upload'));
  }, []);

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions py-5 px-md-5">
        <div className="row justify-content-center mt-5">
          <div className="col-12">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiddingQuoteStart;
